import { BaseService } from './base.service';

export class RoleService extends BaseService {
    baseUrl = '/role';
}
